import { create } from 'zustand';

const useActivityLMSPurchaseStore = create((set) => ({
    purchasedCourses: {},
    setPurchaseComplete: (courseId) => set((state) => ({
        purchasedCourses: {
            ...state.purchasedCourses,
            [courseId]: true
        }
    })),
    isPurchased: (courseId) => {
        return (state) => !!state.purchasedCourses[courseId];
    }
}));

export default useActivityLMSPurchaseStore;
